module.exports = "../images/boat-3@2x.jpg?v=2324676";